import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type RegisterBondData = {
  bondId?: number;
  side?: number;
  productCode?: string;
  productType?: number;
  method?: string;
  productPeriod?: number;
  registerDate?: string;
  registerQuantity?: number;
  fullname?: string;
  idCardNo?: string;
  issueDate?: string;
  issueAt?: string;
  phone?: string;
  address?: string;
  email?: string;
  bankAccountNo?: string;
  stockAccountNo?: string;
  amount?: number;
  productCategory?: number;
}

interface RegisterBondState {
  data?: RegisterBondData;
  perform?: number;
}

const initialState: RegisterBondState = {
};

export const registerBondSlice = createSlice({
  name: 'registerBondReducer',
  initialState,
  reducers: {
    saveRegisterBondData($state, action: PayloadAction<RegisterBondData>) {
      $state.data = action.payload;
    },
    savePerform($state, action: PayloadAction<number>) {
      $state.perform = action.payload;
    },
  },
});

export const { saveRegisterBondData, savePerform } = registerBondSlice.actions;

export default registerBondSlice.reducer;
